module.exports = __webpack_public_path__ + "img/TV2.afefffdb.png";